import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import SideBarSkeleton from "../../Components/atoms/SideBarSkeleton";
import SectionHeader from "../../Components/molecules/SectionHeader";
import Table from "../../Components/organisms/Table";
import { RECORDS_LIMIT } from "../../developmentContent/constants";
import { Get } from "../../interceptor/axiosInterceptor";
import useDebounce from "../../resources/customHooks/useDebounce";
import classes from "./ContactRequests.module.css";
import Button from "../../Components/atoms/Button";
import { mergeClass } from "../../resources/utils/helper";
import { MessageModal } from "../../Components/molecules/MessageModal";

export default function ContactRequests() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const debounceSearch = useDebounce(search);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const tableHeader = [
    { id: "fullName", label: "Full Name", style: { width: "15%" } },
    { id: "email", label: "Email", style: { width: "20%" } },
    { id: "phoneNumber", label: "Contact", style: { width: "15%" } },
    { id: "subject", label: "Subject", style: { width: "15%" } },
    { id: "message", label: "Message", style: { width: "20%" } },
    {
      id: "actions",
      style: { width: "15%", textAlign: "center" },
      className: classes.tableHeadings,
      renderValue: (item) => (
        <Button
          className={mergeClass("fs-16 fw-700", classes.actionButton)}
          label="View"
          variant="primary"
          onClick={() => {
            setSelectedItem(item);
            setShowModal(true);
          }}
        />
      ),
    },
  ];

  const tableBody = data?.map((item) => ({
    _id: item._id,
    fullName: item.fullName,
    email: item.email,
    phoneNumber: item.phoneNumber,
    subject: item.subject,
    message: item.message,
  }));

  const getData = async ({ pg = page, _search = debounceSearch }) => {
    setLoading("loadings");
    const params = {
      page: pg,
      search: _search,
      limit: RECORDS_LIMIT,
    };

    const queryParams = new URLSearchParams(params)?.toString();
    const url = "admin/contact-us/all";
    const { response } = await Get({
      route: `${url}?${queryParams}`,
    });

    if (response) {
      setData(response?.data?.data);
      setPage(pg);
      setTotalRecords(response?.data?.totalRecords);
    }
    setLoading("");
  };

  useEffect(() => {
    setPage(1);
    getData({ pg: page, _search: debounceSearch });
  }, [debounceSearch]);

  return (
    <SideBarSkeleton>
      <Container fluid>
        <Row>
          <Col md={12}>
            <SectionHeader
              title="Contact Requests"
              btnClass={classes.btnClass}
              showSearch
              search={search}
              setSearch={setSearch}
            />
          </Col>
          <Col md={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={tableHeader}
                tableData={tableBody}
                currentPage={page}
                totalRecords={totalRecords}
                hasPagination
                {...{ totalRecords, currentPage: page }}
                loading={loading === "loadings"}
                setCurrentPage={(p) => {
                  setPage(p);
                  getData({ pg: p, _search: debounceSearch });
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
      {showModal && (
        <MessageModal
          showModal={showModal}
          setShowModal={setShowModal}
          loading={loading === "loadings"}
          data={selectedItem}
        />
      )}
    </SideBarSkeleton>
  );
}
